export interface IFitCcPopupItem {
    text: string,
    icon?: string,
    disabled?: boolean,
    click?: Function
}